import React, {Component} from "react";
import CurrencyConfiguration from "../../../SystemConfiguration/CurrencyConfiguration/CurrencyConfiguration";
import {FormattedMessage} from "react-intl";
import "./SalesTableHeader.css";

class SalesTableHeaderRes extends Component {


    render() {
        return (
            <thead>
                <tr>
                    <th>
                        <FormattedMessage id="app.admin.all.order.table.id"
                                          defaultMessage="Order Id"
                                          description=""/>
                    </th>
                    <th>
                        {!this.props.hideOrderStatus ?
                            "注文日"
                            :
                            "発送日"
                        }
                    </th>
                    <th>お届け先住所・名前</th>
                    <th>
                        <FormattedMessage id="app.admin.all.order.table.order-cost"
                                          defaultMessage="Order Cost"
                                          description=""/>($)
                    </th>
                    <th>
                        <FormattedMessage id="app.admin.all.order.table.order-total"
                                          defaultMessage="Order Total"
                                          description=""/>(¥)
                    </th>
                    <th>進捗</th>
                    <th>
                        <FormattedMessage id="app.admin.all.order.table.action"
                                          defaultMessage="Actions"
                                          description=""/>
                    </th>
                </tr>
            </thead>


        );

    }
}

export default SalesTableHeaderRes;





// WEBPACK FOOTER //
// ./src/components/Admin/Sales/ViewAllSales/SalesTableHeader/salesTableHeaderRes.js